import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 6l16 0","key":"svg-0"}],["path",{"d":"M4 12l16 0","key":"svg-1"}],["path",{"d":"M4 18l12 0","key":"svg-2"}]]

/**
 * IconAlignJustified
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYWxpZ24tanVzdGlmaWVkIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00IDZsMTYgMCIgLz4KICA8cGF0aCBkPSJNNCAxMmwxNiAwIiAvPgogIDxwYXRoIGQ9Ik00IDE4bDEyIDAiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/align-justified
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconAlignJustified = createReactComponent('outline', 'align-justified', 'AlignJustified', __iconNode);

export default IconAlignJustified;